import { render, staticRenderFns } from "./MobileSafetyEquipmentCheckCreate.vue?vue&type=template&id=670178bd&scoped=true&"
import script from "./MobileSafetyEquipmentCheckCreate.vue?vue&type=script&lang=js&"
export * from "./MobileSafetyEquipmentCheckCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670178bd",
  null
  
)

export default component.exports